/**
 * Calculate final price from net price adding fees and taxes
 * @param netPrice net price in cents
 * @param fees array of fees and taxes
 * @param is_online whether the booking is from an online channel
 * @returns final price, fee amount and tax amount
 */
export function calculateOnNet(
    netPrice: number,
    fees: Array<{ percentage: number; usd: number; is_tax: boolean; online_only?: boolean }>,
    is_online: boolean = false,
) {
    // exception for 0 price items
    if (netPrice === 0) {
        return {
            finalPrice: 0,
            feeAmount: 0,
            taxAmount: 0,
        };
    }

    let finalPrice = netPrice;
    let feeAmount = 0;
    let taxAmount = 0;

    // first round, fees on the netPrice
    fees.filter((e) => {
        if (!e.is_tax) {
            if (e.online_only && !is_online) {
                return false;
            }
            return true;
        }
        return false;
    }).forEach((fee) => {
        if (fee.percentage !== 0) {
            feeAmount += Math.ceil((netPrice * fee.percentage) / 100);
        }
        if (fee.usd !== 0) {
            feeAmount += fee.usd * 100;
        }
    });

    // second round, taxes on netPrice + fees
    finalPrice += feeAmount;
    fees.filter((e) => {
        if (e.is_tax) {
            if (e.online_only && !is_online) {
                return false;
            }
            return true;
        }
        return false;
    }).forEach((fee) => {
        if (fee.percentage !== 0) {
            taxAmount += Math.ceil((finalPrice * fee.percentage) / 100);
        }
        if (fee.usd !== 0) {
            taxAmount += fee.usd * 100;
        }
    });
    finalPrice += taxAmount;

    return {
        finalPrice,
        feeAmount,
        taxAmount,
    };
}

// define price based on ticket type and option
export function definePrice(priceMatrix, ticketOptionName) {
    // if price matrix is empty, return
    if (Object.keys(priceMatrix).length === 0) {
        return;
    }
    const selectedOptionName = ticketOptionName;
    const price = priceMatrix[selectedOptionName];
    // if price is undefined, show error
    if (price === undefined) {
        throw new Error(`Price not found for option: ${selectedOptionName}`);
    }
    return price || 0;
}
